var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 150 150",
    fill: "#025add",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 122.19a.966.966 0 0 1 -.16-.012 1 1 0 0 1 -.84-.988v-92.38a1 1 0 0 1 1-1h30.652a1 1 0 0 1 .88.526l6.948 12.943h67.877a1 1 0 0 1 1 1v13.412a1 1 0 0 1 -1 1h-83.991l-21.417 64.809a1 1 0 0 1 -.949.69zm1-92.38v85.167l19.7-59.6a1 1 0 0 1 .949-.686h83.713v-11.412h-67.481a1 1 0 0 1 -.881-.527l-6.947-12.942z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m117.357 122.19h-106.357a1 1 0 0 1 -.949-1.314l21.649-65.499a1 1 0 0 1 .949-.686h106.351a1 1 0 0 1 .949 1.314l-21.643 65.5a1 1 0 0 1 -.949.685zm-104.973-2h104.25l20.982-63.5h-104.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m74.119 110.1a19.718 19.718 0 1 1 19.717-19.718 19.74 19.74 0 0 1 -19.717 19.718zm0-37.435a17.718 17.718 0 1 0 17.717 17.717 17.737 17.737 0 0 0 -17.717-17.717z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m74.118 102.789a12.407 12.407 0 1 1 12.409-12.407 12.421 12.421 0 0 1 -12.409 12.407zm0-22.813a10.407 10.407 0 1 0 10.409 10.406 10.418 10.418 0 0 0 -10.409-10.406z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m74.118 95.478a5.1 5.1 0 1 1 5.1-5.1 5.1 5.1 0 0 1 -5.1 5.1zm0-8.191a3.1 3.1 0 1 0 3.1 3.095 3.1 3.1 0 0 0 -3.1-3.095z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m74.119 75.315a1 1 0 0 1 -1-1v-5.3a1 1 0 0 1 2 0v5.3a1 1 0 0 1 -1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m74.119 112.75a1 1 0 0 1 -1-1v-5.3a1 1 0 0 1 2 0v5.3a1 1 0 0 1 -1 1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m95.487 91.382h-5.3a1 1 0 0 1 0-2h5.3a1 1 0 0 1 0 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m58.052 91.382h-5.3a1 1 0 0 1 0-2h5.3a1 1 0 0 1 0 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m113.743 117.191a1 1 0 0 1 -.949-1.315l3.717-11.249a1 1 0 1 1 1.9.628l-3.718 11.245a1 1 0 0 1 -.95.691z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m119.2 100.692a1 1 0 0 1 -.949-1.315l9.582-29a1 1 0 0 1 1.9.628l-9.582 29a1 1 0 0 1 -.951.687z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSecure);
export default __webpack_public_path__ + "static/media/service-secure.f70cec05593133a2b18231579a8b3d6e.svg";
export { ForwardRef as ReactComponent };